module.exports = __webpack_public_path__ + "static/media/clyh.68ec3bfb2831649f74ebefe184e8896b.svg";